import React from 'react';
import Grid from '@mui/material/Grid';
import { Divider, RichTextRenderer, Typography, useScreenSize } from '@raisin/components-lib';
import { OfferDetailField } from '../types';
import * as S from './styles';

export interface BankOffersDetailFieldProps {
  field: OfferDetailField;
  isLastField: boolean;
}

const BankOffersDetailField: React.FC<BankOffersDetailFieldProps> = ({ field, isLastField }) => {
  const screen = useScreenSize();
  const isMobile = screen !== 'mobile';

  if (!field.isVisible) return null;

  return (
    <S.BankOffersDetailFields xs={12} lg={9}>
      <S.DetailFieldBox sx={{ display: 'flex' }} className="wrapper">
        <Grid container>
          {field.title && (
            <Grid item xs={12} sm={4} sx={{ mb: { xs: 1, sm: 0 } }}>
              <Typography variant="button">{field.title}</Typography>
            </Grid>
          )}
          {field?.isHTMLContentAvailable ? (
            <Grid
              item
              xs={12}
              sm={8}
              sx={{
                pl: {
                  xs: 0,
                  sm: field.title ? 6 : 0,
                },
              }}
            >
              <Typography sx={{ whiteSpace: 'pre-line' }} variant="body1">
                <RichTextRenderer text={field.value} />
              </Typography>
            </Grid>
          ) : (
            <Grid
              item
              xs={12}
              sm={8}
              sx={{
                pl: {
                  xs: 0,
                  sm: field.title ? 6 : 0,
                },
              }}
            >
              <Typography sx={{ whiteSpace: 'pre-line' }} variant="body1">
                {field.value}
              </Typography>
            </Grid>
          )}
        </Grid>
      </S.DetailFieldBox>
      {isLastField && isMobile && <Divider light />}
    </S.BankOffersDetailFields>
  );
};

export default BankOffersDetailField;
